import type { Incentive, Discount } from '|/services/purchase-funding/types';

/**
 * Calculates the vehicle price after subtracting incentives and discounts
 */
export const calculateAdjustedPrice = (
  vehiclePrice: number,
  incentives: Incentive[],
  discounts?: Discount[]
): number => {
  let adjustedPrice = vehiclePrice;

  // Subtract incentives
  if (incentives.length > 0) {
    const totalIncentives = incentives.reduce((total, incentive) => total + incentive.amount, 0);
    adjustedPrice -= totalIncentives;
  }

  // Subtract discounts
  if (discounts && discounts.length > 0) {
    const totalDiscounts = discounts.reduce((total, discount) => total + discount.amount, 0);
    adjustedPrice -= totalDiscounts;
  }

  return Math.max(0, adjustedPrice);
};
